<template>
  <nav aria-label="breadcrumbs" class="s-breadcrumbs">
    <ol class="s-breadcrumbs__list">
      <template v-for="(breadcrumb, index) in breadcrumbs" :key="index">
        <i
          v-if="index !== 0"
          class="s-breadcrumbs__list__item__icon fa-regular fa-chevron-right"
          :class="`s-breadcrumbs__list__item__icon--${color}`"
        />
        <li class="s-breadcrumbs__list__item">
          <component
            :is="tag"
            v-bind="breadcrumb"
            v-if="(breadcrumb.href || breadcrumb.to) && !isLastItem(index)"
            class="s-breadcrumbs__list__item__link"
            :class="`s-breadcrumbs__list__item__link--${color}`"
          >
            {{ breadcrumb.label }}
          </component>
          <span
            v-else
            class="s-breadcrumbs__list__item__name"
            :class="`s-breadcrumbs__list__item__name--${color}`"
          >
            {{ breadcrumb.label }}
          </span>
        </li>
      </template>
    </ol>
  </nav>
</template>

<script setup lang="ts">
/**
 * Breadcrumb navigation component with customizable styling and routing.
 * Displays navigation path with chevron separators. Last item is non-clickable.
 */
import type { Component } from "vue";

const props = withDefaults(
  defineProps<{
    breadcrumbs: (Record<string, unknown> & {
      href?: string;
      label: string;
      to?: string | { name: string; props?: Record<string, unknown> };
    })[];
    color?: "gray" | "white";
    tag?: Component | "a";
  }>(),
  { color: "gray", tag: "a" },
);

const isLastItem = (index: number) => {
  return index === props.breadcrumbs.length - 1;
};
</script>

<style lang="postcss">
.s-breadcrumbs {
  &__list {
    @apply flex list-none flex-wrap items-center p-0 gap-2;

    &__item {
      &__link {
        @apply text-sm no-underline;

        &--gray {
          @apply text-primary-700;
          &:hover {
            @apply text-primary-500;
          }
        }

        &--white {
          @apply text-white;
          &:hover {
            @apply text-gray-100;
          }
        }
      }

      &__name,
      &__icon {
        @apply text-sm;

        &--gray {
          @apply text-gray-600;
        }
        &--white {
          @apply text-white;
        }
      }
    }
  }
}
</style>
